import { MASTER_TEMPLATE_COMPONENT_CONFIGS } from "arv-extends/constants";

MASTER_TEMPLATE_COMPONENT_CONFIGS.BANNER_CAROUSEL.ARROWS.base = "icomoon-";

export { MASTER_TEMPLATE_COMPONENT_CONFIGS };
